import React, { Suspense, lazy } from 'react';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import { router } from 'dva';
import type { RouterAPI } from 'dva';

import globalVars from './utils/global.js';
import SSOComponent from './routes/SSO/index.js';
import UploadFile2 from './routes/pclab2/upload/index.js';
import VideoPage from './routes/pclab2/video/index.js';
import PLTUploadFile from './routes/Plt/upload/index.js';
import PythonInstallGuide from './routes/Python/Python.js';

const Register = lazy(() => import('./routes/Register/Register.js'));
const Result = lazy(() => import('./routes/Result/index.js'));
const Course = lazy(() => import('./routes/Course/Course.js'));
const Plt = lazy(() => import('./routes/Plt/Plt.js'));
const PclabIntro2 = lazy(() => import('./routes/pclab2/pclabIntro.js'));
const HeroDbIntro = lazy(() => import('./routes/pclab2/herodb.js'));
const Statistics = lazy(() => import('./routes/Statistics/index.js'));
const { Router, Route, Switch } = router;

export default function RouterConfig(api?: RouterAPI): React.ReactElement {
  if (!api) throw new Error('DVA router API is required');
  const { history } = api;
  const Home =
    globalVars.deploymentSlug === 'ai.ksedu.cn'
      ? lazy(() => import('./routes/Home_ksedu/Home.js'))
      : lazy(() => import('./routes/Home/Home.js'));
  return (
    <ConfigProvider locale={zhCN}>
      <Router history={history}>
        <Suspense fallback={<div className="lds-dual-ring" />}>
          <Switch>
            <Route path="/result" component={Result} />
            <Route path="/register" component={Register} />
            <Route path="/sso/validate/" component={SSOComponent} />
            <Route path="/sso/admin/" component={SSOComponent} />
            <Route path="/sso/web/" component={SSOComponent} />
            <Route path="/course" component={Course} />
            <Route exact path="/plt" component={Plt} />
            <Route path="/plt/upload" component={PLTUploadFile} />
            <Route path="/python" component={PythonInstallGuide} />
            <Route exact path="/pclab2" component={PclabIntro2} />
            <Route exact path="/pclab2/herodb" component={HeroDbIntro} />
            <Route path="/pclab2/upload" component={UploadFile2} />
            <Route path="/pclab2/video" component={VideoPage} />
            <Route path="/statistics" component={Statistics} />
            <Route path="/" component={Home} />
          </Switch>
        </Suspense>
      </Router>
    </ConfigProvider>
  );
}
